export default __webpack_public_path__ + "static/media/Sandals of the Primal Spirit.591dc70c.jpg";